export default "__VITE_ASSET__Bfsa01Ez__"